module.exports = __webpack_public_path__ + "img/a1.0c157748.jpg";